import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorityDecision } from 'manager/user-authority-constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-c103',
  templateUrl: './c103.component.html',
  styleUrls: ['./c103.component.scss', '../platform.component.scss'],
})

/**
 * 課題・ソリューション登録完了
 */
export class C103Component extends PlatformComponent {
  // ステータスを格納
  status: string = this.route.snapshot.queryParams.status;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {}

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   */
  public moveB211orMoveB212(): void {
    // 自治体 or 事務局ユーザが否か
    if (
      this.commonService.decisionUserAuthority(
        false,
        new AuthorityDecision({
          user_1: true,
          user_4: true,
        })
      )
    ) {
      // 自治体 or 事務局ユーザの場合

      // 会員プロフィール(自治体)(B211)へ遷移
      this.router.navigate(['pages/platform/b211/' + this.loginUser.member_id]);
    } else {
      // 民間団体の場合

      // 会員プロフィール(民間団体)(B212)へ遷移
      this.router.navigate(['pages/platform/b212/' + this.loginUser.member_id]);
    }
  }
}
